<template>
  <v-dialog v-model="internalDialog" scrollable>
    <v-card data-test="meta-detail-dialog">
      <v-card-title class="headline"> {{ title }} </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="height: 70vh">
        <pre class="json-content">{{ data }}</pre>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat
          @click="internalDialog = false"
          data-test="close-meta-detail-dialog-btn"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Object, Array, String],
      default: "",
    },
    title: {
      type: String,
      default: "Meta Detail",
    },
  },
  computed: {
    internalDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped>
.json-content {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
